import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-green-btn",
  "use": "icon-green-btn-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-green-btn\"><path d=\"M399.399 512.246l292.155-292.16c12.27799999-12.27 12.278-32.186-1e-8-44.457-12.27-12.27799999-32.186-12.278-44.45699999 0l-314.38699999 314.389c-12.28099999 12.27-12.281 32.186-1e-8 44.457l314.388 314.38800001c6.137 6.14 14.183 9.211 22.228 9.21099999s16.092-3.071 22.228-9.211c12.28099999-12.27 12.281-32.186 0-44.457l-292.157-292.161z\" p-id=\"89209\" fill=\"#ABE3C6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol